/**
 * Utility class for pack handler
 *
 * @author John Lukose <john.lukose@quikr.com>
 */

import store from '../../store';
import FreeLocality from './others/freeLocality';
import JobsPostAdRequest from './jobsPostAdRequest';
import { reduxActionUpdateSelectedPack } from '../../actions/PostAdActions';

export const PACKS = {
  FREE: 'freeAd',
  GOLD: 'goldAd',
  GOLD_URGENT: 'goldUrgentAd',
  PPA: 'ppaAd',
  SPOTLIGHT: 'spotlightAd',
  WFH: 'wfhAd',
  GOLD_SUB_3: 'goldSub3',
  GOLD_SUB_5: 'goldSub5',
  GOLD_SUB_10: 'goldSub10'
};

export const PACKS_TYPE = {
  FREE: '',
  GOLD: 'T',
  GOLD_URGENT: 'HT',
  PPA: 'BT',
  GOLD_SUB_3: 'F',
  GOLD_SUB_5: 'S',
  GOLD_SUB_10: 'TR'
};

let packDetails = [
  {
    pack: PACKS.FREE,
    show: 1,
    supportsCredits: 1,
    displayName: 'FREE AD',
    subTitle: 'Normal x applications',
    price: 0,
    credits: 0,
    validity: '5 days',
    rightText: '',
    benefits: ['Limited applications'],
    isAd: 1,
    adType: PACKS_TYPE.FREE
  },
  {
    pack: PACKS.GOLD,
    show: 1,
    supportsCredits: 1,
    displayName: 'GOLD AD',
    subTitle: '10 x applications',
    subTitle2: 'Most Popular',
    price: null,
    credits: 1,
    validity: '10 days',
    rightText: '',
    benefits: [
      'Validity 10 days',
      'View all applications',
      'Top of page promotion website app & emails',
      'Highlighted as \'Gold\''
    ],
    subPacks: [],
    isAd: 1,
    adType: PACKS_TYPE.GOLD
  },
  {
    pack: PACKS.GOLD_URGENT,
    show: 1,
    supportsCredits: 0,
    displayName: 'Gold + Urgent',
    subTitle: '20 x applications',
    price: null,
    creditPrice: 0,
    validity: '5 days',
    rightText: '',
    benefits: [
      'View all applications',
      'Top of page promotion website app & emails',
      'Highlighted as \'Gold + Urgent\''
    ],
    isAd: 1,
    adType: PACKS_TYPE.GOLD_URGENT
  },
  {
    pack: PACKS.PPA,
    show: 0,
    supportsCredits: 0,
    displayName: 'Pay Per 50 Applicant',
    subTitle: '50 applicants or refund',
    price: null,
    creditPrice: 0,
    validity: '45 Days',
    rightText: 'Guarantee',
    benefits: [
      'Validity 10 days',
      'View all applications',
      'Top of page promotion website app & emails',
      'Highlighted as \'Gold\''
    ],
    isAd: 1,
    adType: PACKS_TYPE.PPA
  }
];

export default class PackHandler {
  static getPackDetails = _ => {
    PackHandler.setPackDetails();
    return packDetails;
  }

  static getPackDetailsByType = type => {
    let result = null;

    packDetails.forEach(pack => {
      if (pack.pack === type) {
        result = pack;
      }
    });

    return result;
  }

  static getGoldAdSubPackDetails = type => {
    let result = null;

    packDetails.forEach(pack => {
      if (pack.pack === PACKS.GOLD && pack.subPacks && pack.subPacks.length > 0) {
        pack.subPacks.forEach(subpack => {
        if (type === subpack.pack)
          result = subpack;
        });
      }
    });

    return result;
  }

  // update values from store
  static setPackDetails = _ => {
    let storeValues = store.getState().jobs;
    let { papPrices } = storeValues.config;
    let { hasCredits } = storeValues.user;

    if(!papPrices)
      return;

    packDetails.forEach(pack => {
      switch (pack.pack) {
        case PACKS.FREE: break;
        case PACKS.GOLD: {
          pack.price = papPrices.top;
          pack.validity = papPrices.topValidity;
          pack.benefits[0] = 'Validity ' + pack.validity;
          if (papPrices.AdPackPurchaseData.length > 0) {
            pack.subPacks[0] = {
              pack: PACKS.GOLD_SUB_3,
              discount: papPrices.AdPackPurchaseData[0].percentage,
              credits: papPrices.AdPackPurchaseData[0].credits,
              price: papPrices.AdPackPurchaseData[0].price,
              duration: papPrices.AdPackPurchaseData[0].duration,
              durationType: papPrices.AdPackPurchaseData[0].durationType,
              adType: PACKS_TYPE.GOLD_SUB_3
            };
            pack.subPacks[1] = {
              pack: PACKS.GOLD_SUB_5,
              discount: papPrices.AdPackPurchaseData[1].percentage,
              credits: papPrices.AdPackPurchaseData[1].credits,
              price: papPrices.AdPackPurchaseData[1].price,
              duration: papPrices.AdPackPurchaseData[1].duration,
              durationType: papPrices.AdPackPurchaseData[1].durationType,
              adType: PACKS_TYPE.GOLD_SUB_5
            };
            pack.subPacks[2] = {
              pack: PACKS.GOLD_SUB_10,
              discount: papPrices.AdPackPurchaseData[2].percentage,
              credits: papPrices.AdPackPurchaseData[2].credits,
              price: papPrices.AdPackPurchaseData[2].price,
              duration: papPrices.AdPackPurchaseData[2].duration,
              durationType: papPrices.AdPackPurchaseData[2].durationType,
              adType: PACKS_TYPE.GOLD_SUB_10
            };
          }

          break;
        }
        case PACKS.GOLD_URGENT: {
          pack.price = papPrices.tophigh;
          pack.validity = papPrices.tophighValidity;
          pack.benefits[0] = 'Validity ' + pack.validity;
          pack.show = hasCredits ? 0 : 1;
          break;
        }
        case PACKS.PPA: {
          if (papPrices.ppa) {
            pack.price = papPrices.ppa.minUnits * papPrices.ppa.pricePerUnit;
            pack.validity = papPrices.ppaValidity;
          }
          pack.benefits[0] = 'Validity ' + pack.validity;
          pack.show = papPrices.isPayPerApplicantEnabled && !hasCredits ? 1 : 0;
          break;
        }
      }
    });
  }

  static updateSelectedPack = (selectedPack, selectedSubPack, type) => {
    let storeValues = store.getState().jobs;
    let storePack = storeValues.postAdRequest.others.selectedPack;
    let storeSubPack = storeValues.postAdRequest.others.selectedSubPack;

    // unselecting sub pack
    if (storeSubPack === selectedSubPack) {
      selectedSubPack = null;
    }

    // unselecting pack
    if (storePack === selectedPack && 'packClick' === type) {
      selectedPack = null;
      selectedSubPack = null;
    }

    let pack = {
      selectedPack,
      selectedSubPack
    };

    store.dispatch(reduxActionUpdateSelectedPack(pack));
    JobsPostAdRequest.reduxUpdateCompanyDetails();
  }

  static getSelectedPackPrice = type => {
    let storeValues = store.getState().jobs;
    let storePack = storeValues.postAdRequest.others.selectedPack;
    let storeSubPack = storeValues.postAdRequest.others.selectedSubPack;
    let price = 0;

    packDetails.forEach(pack => {
      if (pack.pack === storePack && (type === storePack || type === storeSubPack)) {
        price = pack.price;
        if (storeSubPack && pack.subPacks.length > 0) {
          pack.subPacks.forEach(subPack => {
            if( subPack.pack === storeSubPack) {
              price = subPack.price;
            }
          });
        }
      }
    });

    return price;
  }
}



// WEBPACK FOOTER //
// ../q-jobs/src/utils/JobsPostAd/packHandler.js